import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { ICTProjectSearchOptions } from "src/app/Models/ictProjectSearchOptions.model";
import { ictProjectModel } from "src/app/Models/ictProjectModel.model";

@Injectable({
  providedIn: "root",
})
export class IctprojectService {
  httpOptions = {
    headers: new HttpHeaders({
      Accept: "application/json",
      Authorization: "Bearer " + localStorage.getItem("token"),
    }),
  };
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  insertProject(projectInfo): Observable<any> {
    const url = this.apiUrl + "ICTProject/CreateProject";
    return this.http.post<any>(url, projectInfo, this.httpOptions);
  }

  insertProjectToHistory(projectInfo): Observable<any> {
    const url = this.apiUrl + "ICTProject/CreateProjectHistory";
    return this.http.post<any>(url, projectInfo, this.httpOptions);
  }

  getProjectsBySearchOptions(
    searchOptions: ICTProjectSearchOptions
  ): Observable<any> {
    const url = this.apiUrl + "ICTProject/GetProjectsByContentType";
    return this.http.post<any>(url, searchOptions, this.httpOptions);
  }

  getProjectsByStatusAndContentType(
    status: string,
    contentType: string,
    from: number,
    size: number
  ) {
    const url =
      this.apiUrl +
      "ICTProject/GetProjectsHistoryByStatusAndContentType/" +
      status +
      "/" +
      contentType +
      "/" +
      from +
      "/" +
      size;
    return this.http.get<any>(url, this.httpOptions);
  }

  getProjectCountByStatusAndContentType(status: string, contentType: string) {
    const url =
      this.apiUrl +
      "ICTProject/GetProjectHistoryCountByStatusAndContentType/" +
      status +
      "/" +
      contentType;
    return this.http.get<any>(url, this.httpOptions);
  }

  getICTProjectById(projectId: string) {
    const url = this.apiUrl + "ICTProject/GetProjectById/" + projectId;
    return this.http.get<any>(url, this.httpOptions);
  }

  getICTProjectHistoryById(projectId: string) {
    const url = this.apiUrl + "ICTProject/GetProjectHistoryById/" + projectId;
    return this.http.get<any>(url, this.httpOptions);
  }

  getICTProjectsByContentType(contentType: string, from: any, size: any) {
    const url =
      this.apiUrl +
      "ICTProject/GetProjectsByContentType/" +
      from +
      "/" +
      size +
      "/" +
      contentType;
    return this.http.get<any>(url, this.httpOptions);
  }
  deleteICTProjectById(projectId: string) {
    const url = this.apiUrl + "ICTProject/DeleteICTProject/" + projectId;
    return this.http.get<any>(url, this.httpOptions);
  }

  deleteICTProjectHistoryById(projectId: string) {
    const url = this.apiUrl + "ICTProject/DeleteICTProjectHistory/" + projectId;
    return this.http.get<any>(url, this.httpOptions);
  }

  public deleteMultipleICTProjects(projectIds: string[]): Observable<any> {
    const url = this.apiUrl + "ICTProject/DeleteMultipleICTProjects/";
    return this.http.post<any>(url, projectIds);
  }

  public deleteMultipleICTProjectsHistory(
    projectIds: string[]
  ): Observable<any> {
    const url = this.apiUrl + "ICTProject/DeleteMultipleICTProjectsHistory/";
    return this.http.post<any>(url, projectIds);
  }

  getAllProjectsByContentType(
    contentType: string,
    from: number,
    size: number
  ): Observable<any> {
    const url = this.apiUrl + "ICTProject/GetProjectsByContentType/";
    return this.http.get<any>(
      url + from + "/" + size + "/" + contentType,
      this.httpOptions
    );
  }

  uploadMultipleProjects(file): Observable<any> {
    const url = this.apiUrl + "ICTProject/UploadMultipleProjects";
    const formData: FormData = new FormData();
    formData.append("Files", file, file.name);
    return this.http.post<any>(url, formData, this.httpOptions);
  }

  searchICTProject(contentType: string, searchTerm: string) {
    const url = this.apiUrl + "ICTProject/SearchICTProjectWithContentType/";
    return this.http.get<any>(
      url + contentType + "/" + searchTerm,
      this.httpOptions
    );
  }
  searchGridForApprovedICT(
    contentType: any,
    searchTerm: string,
    from: number,
    size: number
  ) {
    const url = this.apiUrl + "ICTProject/GridSearch";
    return this.http.get<any>(
      url +
        "?contentType=" +
        contentType +
        "&searchTerm=" +
        searchTerm +
        "&from=" +
        from +
        "&size=" +
        size,
      this.httpOptions
    );
  }
  updateICTProject(projectInfo: ictProjectModel) {
    const url = this.apiUrl + "ICTProject/UpdateProject";
    return this.http.post<any>(url, projectInfo, this.httpOptions);
  }

  lockICTProject(projectId: string) {
    const url = this.apiUrl + "ICTProject/LockProject/" + projectId;
    return this.http.get<any>(url, this.httpOptions);
  }
  updateICTViewCount(projectId:string){
    const url = this.apiUrl + `ICTProject/UpdateViewCount?projectId=${projectId}`;
    return this.http.post<any>(url, this.httpOptions);
  }
  updateICTDownloadCount(projectId:string){
    const url = this.apiUrl + `ICTProject/UpdateDownloadCount?projectId=${projectId}`;
    return this.http.post<any>(url, this.httpOptions);
  }
}
